import type { MapContext } from "../map/types";
<if(input.pointsOfInterest && input.pointsOfInterest.length > 0)>
  <context|ctx| from="map">
    $ const { handleWatchListItemToggle, watchListItems } = (ctx || {}) as MapContext;
    <div class="items-carousel">
      <ebay-carousel gap=8 index=0 class="carousel-mapview" no-update-if(state.shouldUpdateCarousel === false)>
        <for|item, index| of=input.pointsOfInterest || []>
          <@item>
            <map-item itemCard=item.itemCard handleWatchListItemToggle=handleWatchListItemToggle watchListItems=watchListItems key=String(index)/>
          </@item>
        </for>
      </ebay-carousel>
    </div>
  </context>
</if>
